/* eslint complexity: 0 */
import {
    RECEIVE_HERO_IMAGE_TEMPLATE,
    RECEIVE_HERO_IMAGE_DEFAULT,
    SET_DESTINATION_URGENCY_MEASUREMENTS,
    SET_DESTINATION_INFOGRAPHIC,
    SET_LISTINGS
} from '../actions/action-types';

export default (state = {}, action) => {
    switch (action.type) {
        case RECEIVE_HERO_IMAGE_TEMPLATE:
            return {
                ...state,
                details: {
                    ...state.details,
                    heroImageTemplate: action.payload
                }
            };
        case RECEIVE_HERO_IMAGE_DEFAULT:
            return {
                ...state,
                details: {
                    ...state.details,
                    heroImageDefault: action.imageUrl
                }
            };
        case SET_DESTINATION_URGENCY_MEASUREMENTS:
            return {
                ...state,
                urgencyVisitorCount: action.visitorCount
            };
        case SET_DESTINATION_INFOGRAPHIC:
            return {
                ...state,
                infographic: action.payload
            };
        case SET_LISTINGS:
            return {
                ...state,
                listings: action.listings,
                refinementKey: action.refinementKey,
                inventoryCount: action.inventoryCount
            };
        default:
            return state;
    }
};
